import React from 'react';

function ErrorSmileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
      viewBox="0 0 100 100"
    >
      <path
        fill="#EF4136"
        d="M37.086 44.977c-2.66 0-4.434-1.826-4.434-4.566V21.233c0-2.74 1.774-4.567 4.434-4.567 2.661 0 4.435 1.827 4.435 4.567V40.41c0 2.283-2.218 4.566-4.435 4.566zm29.267-4.566V21.233c0-2.74-1.773-4.567-4.434-4.567-2.66 0-4.434 1.827-4.434 4.567V40.41c0 2.74 1.773 4.566 4.434 4.566 2.66 0 4.434-2.283 4.434-4.566zM20.236 81.05c4.877-8.22 16.85-13.7 29.71-13.7 12.416 0 23.946 5.023 29.267 12.786 1.33 2.283 3.991 2.74 6.208 1.37 2.218-1.37 2.661-4.11 1.33-6.393C79.658 64.612 65.91 58.219 50.39 58.219c-16.407 0-31.04 7.306-37.248 18.265-1.33 2.283-.444 5.023 1.33 6.393.887.456 1.33.456 2.217.456s2.66-.913 3.548-2.283z"
      ></path>
    </svg>
  );
}

export default ErrorSmileIcon;
